import { render, staticRenderFns } from "./MyPrice.vue?vue&type=template&id=7d3ec7f0&"
import script from "./MyPrice.vue?vue&type=script&setup=true&lang=js&"
export * from "./MyPrice.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MyPrice.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports